export const BASE_URL: any =
  process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_BACKEND_URL
    : process.env.REACT_APP_BACKEND_URL

// GET PLANS
export const GET_PLANS: any = `/user/plan`
export const GET_FAQS: any = '/faqs'
export const CHANGE_PASWWORD: any = '/user/password/update'
export const UPDATE_PROFILE: any = '/user/update/profile'
export const PIN_RESET: any = '/user/pin/reset'
export const PIN_CREATE: any = '/user/pin/create'
export const GET_NEXTOFKIN: any = '/user/next-of-kin'
export const POST_NEXTOFKIN: any = '/user/next-of-kin/update'
export const UPDATE_PROFILEPIC: any = '/user/avatar/update'
export const GET_PORTFOLIO: any = '/user/portfolio'

export const VERIFY_BANK_NUMBER: any = `/user/bank/resolve`
export const GET_ALL_BANKS: any = `/banks`
export const GET_REFERRAL_DETAILS: any = `/user/referral`
// BANK SETTINGS
export const BANK_SETTINGS: any = `/user/bank/create`

// GET ALL BANKS

//GET MY BANKS
export const GET_MY_BANKS: any = 'user/bank'

// GET REFERRAL DETAILS

// GET REFERRAL CODE

export const GET_REFERRAL_CODE: any = '/user/referral/code'

// COLLABO
export const GET_COLLABO_INVITES: any = 'user/collabo/invite'
export const GET_COLLABO: any = 'user/collabo'
export const SEARCH_USER: any = 'user/search'
